import CustomerImportBatchStatusBadge from "./CustomerImportBatchStatusBadge";

function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("nl-NL");
}

export default function CustomerImportHistoryTable({ items, loading, onOpen }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-900">Importbatches</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-xs">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500">
              <th className="px-2 py-2">Datum</th>
              <th className="px-2 py-2">Batch-id</th>
              <th className="px-2 py-2">Bron</th>
              <th className="px-2 py-2">Status</th>
              <th className="px-2 py-2">Resultaat</th>
              <th className="px-2 py-2">Actie</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item._id} className="border-b border-slate-100 last:border-b-0">
                <td className="px-2 py-2 text-slate-700">{formatDate(item.createdAt)}</td>
                <td className="px-2 py-2 text-slate-900">{item.importBatchId || item._id}</td>
                <td className="px-2 py-2 text-slate-700">{item.sourceType || "-"}</td>
                <td className="px-2 py-2"><CustomerImportBatchStatusBadge status={item.status} /></td>
                <td className="px-2 py-2 text-slate-700">+{item.summary?.created || 0} / ~{item.summary?.updated || 0} / -{item.summary?.skipped || 0} / !{item.summary?.failed || 0}</td>
                <td className="px-2 py-2">
                  <button type="button" onClick={() => onOpen(item)} className="rounded border border-slate-200 px-2 py-1 text-xs text-slate-700">Open</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!loading && items.length === 0 && (
        <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm text-slate-500">Nog geen importbatches gevonden voor deze filters.</div>
      )}
    </div>
  );
}
